import React from 'react';
import { Route, Switch } from 'react-router-dom';

import * as News from './index';

export const routes = [
    {
        exact: true,
        path: '/news',
        component: News.NewsIndex,
    },
    {
        exact: true,
        path: '/news/:id',
        component: () => <div>News.NewsSingle</div>,
    },
];

export const NewsRoutes = props => (
    <Switch>
        {routes.map(r => {
            const Component = r.component || React.createComponent(r.toRender);
            const routeProp = { ...r, component: undefined };
            return <Route key={r.path} {...routeProp} render={() => <Component {...props} />} />;
        })}
    </Switch>
);
export default NewsRoutes;
